import React, { Suspense, ReactElement } from "react";
import { ThemeProvider } from "styled-components";
import { ApolloProvider } from "@apollo/react-hooks";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import styled from "styled-components";

import { deviceSize } from "utils/devices";
import { Provider } from "react-redux";
import graphqlClient from "graphql/client";
import store from "redux/store";

import Navigation from "./components/Navigation/index";
import ErrorToast from "components/Toast/ErrorToast";

// asyncronously lazy import
const Resources = React.lazy(() => import("./pages/Resources/index"));
const AcsOutlines = React.lazy(() => import("./pages/AcsOutlines"));

const defaultTheme: Object = {
  primary: "#343E49",
  secondary: "#63A0DB",
  tertiary: "#C0CCDA",
};

interface Props {
  children: ReactElement;
}

const CombineProviders: React.FC<Props> = ({ children }) => {
  return (
    <Provider store={store}>
      <ApolloProvider client={graphqlClient}>
        <ThemeProvider theme={defaultTheme}>
          <Router>{children}</Router>
        </ThemeProvider>
      </ApolloProvider>
    </Provider>
  );
};

const App: React.FC = () => {
  return (
    <div data-test="app">
      <CombineProviders>
        <>
          <Container>
            <Navigation />
            <Switch>
              <Suspense fallback={<span></span>}>
                <Route
                  exact
                  path={["/", "/search/:search_string"]}
                  component={Resources}
                />
                <Route path="/acs-outlines" component={AcsOutlines} />
              </Suspense>
            </Switch>
          </Container>
          <ErrorToast />
        </>
      </CombineProviders>
    </div>
  );
};

const Container = styled.div`
  margin: auto;
  max-width: ${deviceSize.laptopL};
`;

export default App;
